import { useDispatch } from 'react-redux'
import { addToast } from './toastSlice'

export const useToast = () => {
    const dispatch = useDispatch()
  
    const showToast = (message, type = 'info', duration = 3000) => {
      dispatch(addToast({
        id: Date.now(),
        message,
        type,
        duration
      }))
    }
  
    const showSuccess = (message, duration) => showToast(message, 'success', duration)
    const showError = (message, duration) => showToast(message, 'error', duration)
    const showWarning = (message, duration) => showToast(message, 'warning', duration)
    const showInfo = (message, duration) => showToast(message, 'info', duration)
  
    return {
      showToast,
      showSuccess,
      showError,
      showWarning,
      showInfo
    }
}